/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderCompletedFile
 */
export interface DigitizingMelcoDigitizingModelsOrderCompletedFile {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCompletedFile
     */
    attachment_blob_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCompletedFile
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCompletedFile
     */
    file_extension?: string | null;
}

export function DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderCompletedFile {
    return DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderCompletedFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderCompletedFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachment_blob_url': !exists(json, 'attachment_blob_url') ? undefined : json['attachment_blob_url'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderCompletedFileToJSON(value?: DigitizingMelcoDigitizingModelsOrderCompletedFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachment_blob_url': value.attachment_blob_url,
        'file_name': value.file_name,
        'file_extension': value.file_extension,
    };
}


